export const fileds = [
  {
    attr: 'name',
    name: '素材名称',
    value: '',
    type: 'Input',
    props: {
      placeholder: '请输入',
      rules: {
        required: true,
        message: '请输入',
        target: 'blur'
      }
    }
  },
  {
    attr: 'alias',
    name: '中文名称',
    value: '',
    type: 'Input',
    props: {
      placeholder: '请输入',
      rules: {
        required: false,
        message: '请输入',
        target: 'blur'
      }
    }
  },
  {
    attr: 'cover',
    name: '素材',
    value: '',
    type: 'UploadSingleTencent',
    props: {
      accept: '',
      placeholder: '请选择',
      rules: {
        required: true,
        message: '请选择',
        target: 'blur'
      }
    },
    isBackObj: true
  }
]
export const filedsBatch = [
  {
    attr: 'category_id',
    name: '分类目录',
    value: [],
    type: 'Cascader',
    props: {
      placeholder: '请输入',
      rules: {
        required: false,
        message: '请输入'
      }
    },
    options: []
  },
  {
    attr: 'data',
    name: '批量选择',
    value: [],
    type: 'UploadMulDragTencent',
    props: {
      accept: '',
      placeholder: '请选择',
      rules: {
        required: true,
        message: '请选择',
        target: 'blur'
      }
    },
    isBackObj: true
  }
]
export const moveFileds = [
  {
    attr: 'tar_category_id',
    name: '目录选择',
    value: [],
    type: 'Cascader',
    props: {
      placeholder: '请输入',
      rules: {
        required: true,
        message: '请输入'
      }
    },
    options: []
  }
]
